/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import type { Klass, LexicalNode, LexicalNodeReplacement } from "lexical";

import { CodeHighlightNode, CodeNode } from "@lexical/code";
import { HorizontalRuleNode } from "@lexical/extension";
import { HashtagNode } from "@lexical/hashtag";
import { AutoLinkNode, LinkNode } from "@lexical/link";
import { ListItemNode, ListNode } from "@lexical/list";
import { MarkNode } from "@lexical/mark";
import { OverflowNode } from "@lexical/overflow";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { TableCellNode, TableNode, TableRowNode } from "@lexical/table";

import { CustomBlurbNode } from "./CustomBlurbNode";
import { CustomChartNode } from "./CustomChartNode";
import { CustomETFNode } from "./CustomETFNode";
import { CustomNowReadNode } from "./CustomNowReadNode";
import { CustomRoundTableIntervieweeNode } from "./CustomRoundTableIntervieweeNode";
import { CustomSectionInfoNode } from "./CustomSectionInfoNode";
import { ImageNode } from "./ImageNode";
import { OEmbedNode } from "./OEmbedNode";

const ReadyNodes: Array<Klass<LexicalNode> | LexicalNodeReplacement> = [
  HeadingNode,
  ListNode,
  ListItemNode,
  TableNode,
  TableRowNode,
  TableCellNode,
  CodeNode,
  HashtagNode,
  CodeHighlightNode,
  AutoLinkNode,
  LinkNode,
  OverflowNode,
  ImageNode,
  MarkNode,
  HorizontalRuleNode,

  QuoteNode,
  // CustomQuoteNode,
  // {
  //   replace: QuoteNode,
  //   with: () => $createCustomQuoteNode(),
  //   withKlass: CustomQuoteNode,
  // },

  OEmbedNode,
  CustomETFNode,
  CustomChartNode,
  CustomBlurbNode,
  CustomNowReadNode,
  CustomSectionInfoNode,
  CustomRoundTableIntervieweeNode,
];

export default ReadyNodes;
